import {
  DeltaText,
  createFlagUpdatesChangeExtension,
} from '@spotify/plugin-confidence-flags-react';

export const STRING_CHANGE_EXTENSION = createFlagUpdatesChangeExtension({
  id: 'string-change',
  predicate: ({ change }) => change.fieldType === 'string',
  render: ({ change }) => (
    <DeltaText
      oldText={change.oldValue ?? ''}
      newText={change.newValue ?? ''}
      disableDiff
    />
  ),
});
